import React from 'react';
import Icon from '@/common/components/Icon';
import { Colors } from '@/common/colors/colors';
import { PAGE_SIZE } from '../../../hooks/useCallAnalysis';
import { ActionsWrapper, ScoreBadge } from '../../../callAnalysis.styles';
import {
	formatAnalyzedAt,
	formatScore,
	getAnalysisPathLabel,
	getEvaluationStatusLabel,
	getManualReviewStatusLabel,
	evaluationStatusColor,
	manualReviewStatusColor,
	scoreColor,
} from '../../../helpers/labels';

export const getRaws = ({
	items,
	page,
	onOpen,
	onAnalyze,
}) =>
	items.map((item, index) => (
		<tr key={item._id}>
			<td>{(page - 1) * PAGE_SIZE + index + 1}</td>
			<td>
				{[item.consultant?.name, item.consultant?.surname]
					.filter(Boolean)
					.join(' ') || '—'}
			</td>
			<td>
				<ScoreBadge $bg={scoreColor(item.overall_score)}>
					{formatScore(item.overall_score)}
				</ScoreBadge>
			</td>
			<td>{getAnalysisPathLabel(item.analysis_path)}</td>
			<td>
				<ScoreBadge $bg={evaluationStatusColor(item.evaluation_status)}>
					{getEvaluationStatusLabel(item.evaluation_status)}
				</ScoreBadge>
			</td>
			<td>
				<ScoreBadge $bg={manualReviewStatusColor(item.manual_review?.status)}>
					{getManualReviewStatusLabel(item.manual_review?.status)}
				</ScoreBadge>
			</td>
			<td>
				<ScoreBadge $bg={item.has_critical_error ? '#d32f2f' : '#2e7d32'}>
					{item.has_critical_error ? 'YES' : 'No'}
				</ScoreBadge>
			</td>
			<td>{formatAnalyzedAt(item.analyzed_at)}</td>
			<td>
				<ActionsWrapper>
					<Icon
						name='eye'
						color={Colors.darkBlue}
						onClick={() => onOpen(item)}
					/>
					{item.calling_information && (
						<Icon
							name='rotate-left'
							color={Colors.orange}
							onClick={() =>
								onAnalyze(
									item.calling_information?._id || item.calling_information,
								)
							}
						/>
					)}
				</ActionsWrapper>
			</td>
		</tr>
	));
